var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 100,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6364 4.09091C10.6364 6.34664 8.80118 8.18182 6.54545 8.18182C4.28973 8.18182 2.45455 6.34664 2.45455 4.09091C2.45455 1.83518 4.28973 0 6.54545 0C8.80118 0 10.6364 1.83518 10.6364 4.09091ZM13.0909 16.3636V13.3642C13.0909 10.9579 10.8892 9 8.18182 9H4.90909C2.20173 9 0 10.9579 0 13.3642V16.3636V17.1818V18H13.0909V17.1818V16.3636Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonRequest);
export default __webpack_public_path__ + "static/media/icon-person-request.b2e9298a98738e253855de2dcf5dd4af.svg";
export { ForwardRef as ReactComponent };